import { MDBInput } from "mdb-react-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";

function BillingGeneral({ register, errors, groupType }) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="general-settings" id="general">
        General
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("Name")}</div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            <MDBInput
              {...register("bgrp_name", {
                required: "Name is required",
              })}
              maxLength={30}
            />
            {errors.bgrp_name && (
              <p className="text-danger">{errors.bgrp_name.message}</p>
            )}
          </div>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("billing_Group_Type")}</div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">{groupType}</div>
        </div>
      </div>
    </>
  );
}

export default BillingGeneral;
